import React from "react"
import {
  Button,
  Link,
  TableRow,
  TableCell,
  makeStyles,
  Checkbox,
} from "@material-ui/core"
import { FlagIcon, TextCell } from "components"

const FavoriteItem = ({
  user,
  handleSelect,
  selectedIds = [],
  handleClick,
  ...props
}) => {
  const classes = useStyles()

  const handleEmailClick = () => {
    window.open(`mailto:${user.email}`, "_blank")
  }

  const isSelected = selectedIds.includes(user.id)

  return (
    <TableRow className={classes.root}>
      <TableCell>
        <div className={classes.cell}>
          <Checkbox
            checked={isSelected ? true : false}
            onChange={() => handleSelect(user)}
            name="user"
            color="primary"
          />
          <Link href={`/players/${user.id}`}>
            {user.name}
          </Link>
        </div>
      </TableCell>
      <TextCell>
        <FlagIcon code={user.country} />
      </TextCell>
      <TextCell>
        {user?.positions?.join(",")}
      </TextCell>
      <TextCell>{user?.preferred_foot}</TextCell>
      <TextCell>{user.date_of_birth}</TextCell>
      <TextCell>{user?.height}</TextCell>
      <TextCell>{user?.weight}</TextCell>
      <TextCell>
        {user?.completed_lesson_ids?.length}
      </TextCell>
      <TableCell>
        <div className={classes.tableButtons}>
          <Button
            variant="contained"
            color="secondary"
            onClick={handleEmailClick}
          >
            Email Player
          </Button>
        </div>
      </TableCell>
    </TableRow>
  )
}

export default FavoriteItem

const useStyles = makeStyles((theme) => ({
  root: {},
  tableButtons: {
    display: "flex",
    justifyContent: "flex-end",
  },
  cell: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
}))
